import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VapingRoomsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vaping_rooms"}/>
}
